<script setup lang="ts" name="VCardText">
import type { IVCardTextColor, IVCardTextSize } from '~/types';

const { size, color, text } = defineProps<{
  text: string;
  size?: IVCardTextSize;
  color?: IVCardTextColor;
}>();
</script>

<template>
  <p :class="[size, color]">
    {{ text }}
  </p>
</template>
